import React from 'react';
import { TeamMember } from '../types';
import { SearchIcon } from 'lucide-react';
interface TeamSidebarProps {
  members: TeamMember[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: 'all' | 'active' | 'paused';
  onStatusFilterChange: (status: 'all' | 'active' | 'paused') => void;
  allCount: number;
  activeCount: number;
  pausedCount: number;
}
export function TeamSidebar({
  members,
  selectedId,
  onSelect,
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  allCount,
  activeCount,
  pausedCount
}: TeamSidebarProps) {
  return <div className="w-80 flex-shrink-0 border-r border-gray-200 bg-white flex flex-col h-[calc(100vh-113px)]" data-id="element-214">
      {/* Sticky Header Area */}
      <div className="p-4 border-b border-gray-100 space-y-3 flex-shrink-0" data-id="element-215">
        <div className="relative" data-id="element-216">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-217">
            <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-218" />
          </div>
          <input type="text" placeholder="Search team..." value={searchQuery} onChange={e => onSearchChange(e.target.value)} className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition-colors" data-id="element-219" />
        </div>

        <div className="flex bg-gray-100 rounded-md p-0.5" data-id="element-220">
          <button onClick={() => onStatusFilterChange('all')} className={`flex-1 px-2 py-1 text-[11px] font-medium rounded transition-colors ${statusFilter === 'all' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-221">
            All ({allCount})
          </button>
          <button onClick={() => onStatusFilterChange('active')} className={`flex-1 px-2 py-1 text-[11px] font-medium rounded transition-colors ${statusFilter === 'active' ? 'bg-white text-green-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-222">
            Active ({activeCount})
          </button>
          <button onClick={() => onStatusFilterChange('paused')} className={`flex-1 px-2 py-1 text-[11px] font-medium rounded transition-colors ${statusFilter === 'paused' ? 'bg-white text-amber-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-223">
            Paused ({pausedCount})
          </button>
        </div>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto" data-id="element-224">
        {members.length === 0 ? <div className="p-4 text-center text-sm text-gray-500" data-id="element-225">
            No team members found.
          </div> : <ul className="divide-y divide-gray-50" data-id="element-226">
            {members.map(member => {
          const isSelected = selectedId === member.id;
          const capacityPct = Math.round(member.workload.activeFiles / member.workload.capacity * 100);
          const capacityColor = capacityPct >= 100 ? 'bg-red-500' : capacityPct >= 80 ? 'bg-amber-400' : 'bg-green-500';
          return <li key={member.id} data-id="element-227">
                  <button onClick={() => onSelect(member.id)} className={`w-full text-left flex items-center px-4 py-3 transition-colors ${isSelected ? 'bg-blue-50 border-l-2 border-blue-600 pl-[14px]' : 'hover:bg-gray-50 border-l-2 border-transparent pl-[14px]'} ${!member.isActive ? 'opacity-75' : ''}`} data-id="element-228">
                    <div className="relative flex-shrink-0" data-id="element-229">
                      <img className="h-8 w-8 rounded-full object-cover border border-gray-200" src={member.avatarUrl} alt="" data-id="element-230" />
                      <span className={`absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full border-2 border-white ${member.isActive ? 'bg-green-500' : 'bg-gray-400'}`} data-id="element-231" />
                    </div>

                    <div className="ml-3 flex-1 min-w-0" data-id="element-232">
                      <p className={`text-sm truncate ${isSelected ? 'font-bold text-blue-900' : 'font-semibold text-gray-900'}`} data-id="element-233">
                        {member.name}
                      </p>
                      <p className="text-xs text-gray-500 truncate" data-id="element-234">
                        {member.title}
                      </p>
                    </div>

                    <div className="ml-2 flex flex-col items-end space-y-1" data-id="element-235">
                      <span className={`inline-flex items-center justify-center px-2 py-0.5 rounded-full text-[10px] font-medium ${isSelected ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`} data-id="element-236">
                        {member.workload.activeFiles} files
                      </span>
                      <div className="flex items-center space-x-1" data-id="element-237">
                        <span className={`h-1.5 w-1.5 rounded-full ${capacityColor}`} title={`${capacityPct}% capacity`} data-id="element-238" />
                      </div>
                    </div>
                  </button>
                </li>;
        })}
          </ul>}
      </div>
    </div>;
}